import apiUrl from "./config/config";
import axios from "axios";

class versionApi
{

  static async getVersion()
  {

    try
    {

      const response = await axios(apiUrl + "version");

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}

export default versionApi;
